<template>
  <div class="flex flex-col">
    <div class="flex flex-col border-b-2 border-gray-400">
      <div class="flex flex-row bg-gray-200"
        @click="onToggleOpenTable">
        <AccordionIcon
          :open="openTable"
        />
        <div class="flex-grow"></div>
        <AccordionIcon
          :open="openTable"
        />
      </div>
    </div>
    <div class="flex flex-col"
      v-show="openTable">
      <table class="table-auto">
        <thead>
          <tr>
            <th
              v-for="head in tableHeads"
              :key="head">
              {{ head }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="hover:bg-gray-200"
            v-for="dataItem in dataItems"
            :key="dataItem[uniqueKeyValue]"
            :class="{
              'bg-sky-200 hover:bg-sky-400': selectedEntries[dataItem[uniqueKeyValue]]
            }"
            @click="onClickItem(dataItem)">
            <td
              v-for="key in dataKeyList"
              :key="key">
              {{ dataItem[key] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AccordionIcon from '../AccordionIcon.vue'

export default {
  components: {
    AccordionIcon,
  },
  props: {
    tableHeads: Array,
    dataKeyList: Array,
    dataItems: Array,
    uniqueKeyValue: String,
  },
  data() {
    return {
      openTable: false,
      selectedEntries: {},
    }
  },
  methods: {
    clearSelectedEntries() {
      this.$set(this, 'selectedEntries', {})
    },
    selectAllEntries() {
      for (const dataItem of this.dataItems) {
        this.$set(this.selectedEntries, dataItem[this.uniqueKeyValue], true)
      }
    },
    onClickItem(dataItem) {
      this.$set(this.selectedEntries, dataItem[this.uniqueKeyValue], !this.selectedEntries[dataItem[this.uniqueKeyValue]])
      this.$emit('toggle', dataItem, this.selectedEntries[dataItem[this.uniqueKeyValue]])
    },
    onToggleOpenTable() {
      this.openTable = !this.openTable
      this.$emit('toggleOpen', this.openTable)
    }
  },
}
</script>
